import styled from 'styled-components';
import { Divider } from 'antd';

import { mediaSize } from '../../styles';


export const CommentField = styled.form`
  margin-bottom: 18px;
`;

export const AddButton = styled.button`
  padding: 0;  
  border: none;
  font-size: 14px;
  cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
  color: ${({ disabled, theme }) =>
    disabled ? theme.colors.backgroundDarkGray : theme.colors.fontTangerine};
  background-color:${({ theme }) => theme.colors.white};
`;

export const ButtonWrapper = styled.div`
  position: relative;
  top: 51px;
  right: 15px;
  height: 0;
  text-align: end;
  z-index: 1;
  
  @media (max-width: 493px) {
    top: 72px;
  }
  
   @media (max-width: 351px) {
    top: 97px;
  }
  
  @media (max-width: 1061px) and (min-width: ${mediaSize.desktop}) {
    top: 72px;
  }
`;

export const Placeholder = styled.div`
  color: ${({ theme }) => theme.colors.fontSilverLight};
`;

export const DividerS = styled(Divider)`
  margin: 15px 0;
`;



// WEBPACK FOOTER //
// ./src/components/comments-list/styles.js